module.exports = __webpack_public_path__ + "static/media/blue_eye.08a51b03.svg";